<footer class="footer">
    <div class="container">
        <div class="copyrightNotice">
            <i class="fa fa-copyright"></i> {{copyrightYear}} MatrixCare is a registered trademark of MatrixCare. All rights reserved.
        </div>
    </div>
</footer>